import React, { Component } from 'react';
import { withTranslation } from 'react-i18next';
import { withSuspense } from '../../common/utils';
import { connect } from 'react-redux';
import { CONFIG_SECTION_SUMMARY } from '../../common/utils/Constants';
import { LAYOUT_ORDER_USEFULLINKS } from './Constants';

class PortalFooter extends Component {
    render() {
        const { t } = this.props
        let selectedID = localStorage.getItem("membershipNumber") ? localStorage.getItem("membershipNumber") : "0008010647";
        const onchange = (e) => {
            if (e.target.value != "") {
                if(e.target.value.split('/').length == 2 && e.target.value.split('/')[0] == 'admin') {
                    localStorage.setItem("corpEmployeeDetails", JSON.stringify({
                        "membershipNumber": "69",
                        "fname": "Adam",
                        "lname": "John",
                        "email": "adamjohn@ibsplc.com",
                        "address": {
                            "addressLine1": "46 Cron Street",
                            "addressLine2": "Franz Josef",
                            "streetNumber": "",
                            "district": "",
                            "city": "Waiau",
                            "zip": "7856",
                            "state": "",
                            "country": "New Zealand"
                        }
                    }));
                    e.target.value = e.target.value.split('/')[1];
                    localStorage.setItem("membershipNumber", e.target.value);
                } else {
                    localStorage.setItem("membershipNumber", e.target.value);
                    localStorage.removeItem("corpEmployeeDetails");
                }
                localStorage.removeItem("overView");
                window.location.reload();
            }
        }
        const currentYear =  new Date().getFullYear();
        return (
            <footer class="footer footer--compact">
                <div class="footer__main">
                    <div class="container">
                    <div class="row">
                        <div class="col-lg-4 col-md-4 col-sm-12 order-md-1 order-2">
                            <div class="footerLinks"> 
                                <a target='_blank' href="/help-and-contact?ll=true" class="d-block">Help & contact</a>
                                <a target='_blank' href="/airpoints?ll=true" class="d-block">Airpoints™</a> 
                                <a target='_blank' href="/airpoints-terms-and-conditions?ll=true" class="d-block">Airpoints™ terms and conditions</a> 
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col1sm-12 order-md-2 order-3">
                            <div class="footerLinks"> 
                                <a target='_blank' href="/about-air-new-zealand?ll=true" class="d-block">About Air New Zealand</a> 
                                <a target='_blank' href="/privacy?ll=true" class="d-block">Privacy centre</a> 
                            </div>
                        </div>
                        <div class="col-lg-4 col-md-4 col3sm-12 order-md-3 order-1">
                            <div class="footer__logo"><img src="images/footerlogo.svg" alt={t("altText.footerText")}/></div>
                        </div>
                    </div>
                    
                    </div>
                </div>
                <div class="footer__copy">
                    <div class="container">
                        {/* <input class="tempSelect" type="text" onBlur={onchange} /> */}
                    <div class="footer3">{t("footer.company_name").replace("#YEAR", currentYear)} </div>
                    <div class="terms"><img src="images/footerAlliancelogo.svg" alt={t("altText.starAllianceFooterText")}/></div>
                    </div>
                </div>
            </footer>
        );
    }
}

const mapStateToProps = state => {
    return {
        config: state.configurationReducer[CONFIG_SECTION_SUMMARY] ? state.configurationReducer[CONFIG_SECTION_SUMMARY].ui.layout.elements[LAYOUT_ORDER_USEFULLINKS] : {}
    }
}

const mapDispatchToProps = {}

export default withSuspense()(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(PortalFooter)));
